// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"QuotePage_themeRoot__332F6","startDate":"QuotePage_startDate__14JDB","quotePageHeader":"QuotePage_quotePageHeader__2nTiM"};